import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions } from '../../../../store/actions'
// 증명서신청Tab
import ECDApplySupportListInquire from './ECDApplySupportListInquire'
// 신청현황 Alert
import ECDApplyPopup from './ECDApplyPopup'
// 정부24 전자증명서안내 팝업
import IntroAlertPopup from './IntroAlertPopup'
import * as common from '../../../../assets/js/common.js'

const GovEDocWallet = (props) => {
  const [state, setState] = useState({
    isType: 'apply', // sub-tab 구분
  })

  const [isIntroPopupOpen, setIsOpenPopupOpen] = useState(false)

  useEffect(() => {
    // 단말기에서 Back 키가 눌려졌을때 호출 (Only Android)
    if (common.getDeviceType() === 'MobileApp') {
      const url =
        'https://test.dpaper.kr/apiLoginExt.do?urlScrtyTkn=24T1nSqBecYkrV193NLeHJXWXDCJTT8eY39aDHz4DRnX2twSym&apiUtlinsttCode=145000000000001&encVerVal=2.0&encData=M5rt7yULW7TlMrD3k2qRiuJWqBbOnU+pZdSX81j6oMneV6aRvvFQ4wDWXGtZNHSNw2yw3fgAMiJFX3y/Yqpay9KfrFIqTCWQ8mI5k7mclj5GfKuq5/VWo1w4HeAxh7ABJuPvAndSyH4ncObaKH9JvTTK1Z6kxUX0JXJGmHtwq4JsDJy2ngGhHVp87Hr8dCwVw8RcyvLtvJWUZhHu2qQThMN7EpuKn/M2bijWUtcFTgfogs+UjSlaMhbyAtehVbvs6cMzkdZEkKTXuy9zlxoC+CwUaelOC8krzc44AuVw3PPzt2yBSO9Ve26HWzWItgnLSMs4XSCYvqZRP4kvtSXjfnbDDrfKCpHmGQ5hyYABOpU='
      window.M.execute('exWNStartViewElecDocActivity', url)
    } else {
      // 모바일만 이용 가능하다는 Alert 띄우고 history.back()
    }

    // 전자문서지갑 진입시 전자지갑 생성 여부 체크
    // 1. 개인 이용자 지갑 주소 발급 상태를 확인
    // 2. 미등록 지갑(ecdwTyCode === 2)일 때 미등록 지갑인 경우 지갑 이용자 약관 동의 후 지갑 발급 처리
    // const user = JSON.parse(localStorage.getItem('user'))
    // const loginType = user?.payload?.loginType
    // console.log('user', user?.payload)

    // 정부전자문서지갑 진입시 로그인 유형 체크
    // if (loginType !== 'crtfctf') {
    //   console.log('loginType', loginType)
    //   props.confirm({
    //     title: '확인',
    //     message: '정부전자문서지갑은 공동 인증 로그인 시 이용 가능합니다. \n공동 인증 로그인 화면으로 이동하시겠습니까?',
    //     params: {
    //       type: 'confirm',
    //       okBtnTitle: '지금변경하기',
    //       cancelBtnTitle: '나중에변경하기',
    //       cancelCallback: () => {
    //         return history.goBack()
    //       },
    //       callback: () => {
    //         return user?.payload?.roleDto?.roleId === 3 ? history.replace('/login') : history.replace({ pathname: '/loginCorp' })
    //       },
    //     },
    //   })
    // }

    // 정부24 전자증명서 안내 팝업 체크
    // var cookieCheck = getCookie('popupFlag')
    // if (cookieCheck !== 'N') {
    //   setIsOpenPopupOpen(true)
    // }
  }, [])

  // sub-tab Click Event (증명서신청Tab, 전자문서지갑Tab, 지갑주소Tab)
  const setIsType = (isType) => {
    setState({ ...state, isType })
  }

  /**
   * 쿠키 값 가져오기
   * @param {String} name
   * @returns
   */
  function getCookie(name) {
    var cookie = document.cookie
    if (document.cookie != '') {
      var cookieArray = cookie.split('; ')
      for (var index in cookieArray) {
        var cookieName = cookieArray[index].split('=')
        if (cookieName[0] == 'popupFlag') {
          return cookieName[1]
        }
      }
    }
    return
  }

  function cancel() {
    setIsOpenPopupOpen(false)
  }

  return (
    <>
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <a
            href="#"
            className="page-prev"
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
          >
            뒤로이동
          </a>
          {/* mobile */}
          {/* <h2>정부전자문서지갑</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>전자문서지갑</span>
            <em>정부전자문서지갑</em>
          </div> */}
        </div>
        {/* <div className="govern-wallet">
          <ul className="sub-tab">
            <li className={state.isType === 'apply' ? 'on' : ''}>
              <a href="#" onClick={() => setIsType('apply')}>
                증명서 신청
              </a>
            </li>
            <li className={state.isType === 'wallet' ? 'on' : ''}>
              <a href="#" onClick={() => setIsType('wallet')}>
                전자문서지갑
              </a>
            </li>
            <li className={state.isType === 'address' ? 'on' : ''}>
              <a href="#" onClick={() => setIsType('address')}>
                지갑주소
              </a>
            </li>
          </ul>
          {state.isType === 'apply' && <ECDApplySupportListInquire />}
          {state.isType === 'wallet' && ''}
          {state.isType === 'address' && ''}
        </div> */}
      </div>
      {/* //contents */}

      {/* 알림메시지 */}
      {props.ECDApplyPopup && <ECDApplyPopup setWalletType={() => setState({ ...state, isType: 'wallet' })} />}
      {isIntroPopupOpen && <IntroAlertPopup onClose={cancel} getCookie={getCookie} />}
      {/* <Alert /> */}
      {/* //알림메시지 */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    ECDApplyPopup: state.govcertapply.ECDApplyPopup,
  }
}

const actionCreators = {
  confirm: alertActions.confirm,
}

export default connect(mapStateToProps, actionCreators)(GovEDocWallet)
